import * as React from 'react';
import { HashRouter as Router, Route, Switch, NavLink } from 'react-router-dom';
import DevTools from 'mobx-react-devtools';
import { inject, observer } from 'mobx-react';
import './App.css';
import Login from './views/login/Login';
import ProductView from './views/product-view/ProductView';
import OrderForm from './views/order-form/OrderForm';
import OrderHistory from './views/order-history/OrderHistory';
import NotificationContainer from './components/NotificationContainer';
import {
  PRODUCT_STORE,
  AUTH_STORE,
  CART_STORE,
  ORDER_FORM_STORE,
  ORDER_TYPES_STORE,
  COMPANY_STORE,
  CUSTOMER_STORE,
  FEEDBACK_STORE,
  NOTIFICATION_STORE,
  MODAL_STORE,
  FILTER_STORE } from './constants/constants';
import PrivateRoute from './components/PrivateRoute';
import ModalContainer from './components/ModalContainer';
import Feedback from './components/Feedback';

interface AppState {
  showModal: boolean;
  isLoading: boolean;
  errorText: string;
  feedbackSent: boolean;
}

@inject(
  PRODUCT_STORE,
  AUTH_STORE,
  CART_STORE,
  ORDER_FORM_STORE,
  ORDER_TYPES_STORE,
  COMPANY_STORE,
  CUSTOMER_STORE,
  FEEDBACK_STORE,
  NOTIFICATION_STORE,
  MODAL_STORE,
  FILTER_STORE)
@observer
class App extends React.Component<{}, AppState> {
  state = {
    showModal: false,
    isLoading: false,
    errorText: '',
    feedbackSent: false
  };

  componentDidMount() {
    this.props[COMPANY_STORE].getFromLocalStorage();
    this.props[ORDER_FORM_STORE].getFromLocalStorage();
    this.props[CART_STORE].getFromLocalStorage();
  }

  isDevelopment() {
    if (process.env.NODE_ENV === 'development') {
      return (<DevTools />);
    }
    return;
  }

  logout() {
    this.props[AUTH_STORE].logout();
    this.props[ORDER_FORM_STORE].clearStore();
    this.props[CART_STORE].clearStore();
    this.props[COMPANY_STORE].clearStore();
  }

  clearcache() {
    this.props[AUTH_STORE].clearDrupalCache();
  }

  openFeedbackModal() {
    this.props[MODAL_STORE].setTitle(<h2>Palaute</h2>);
    this.props[MODAL_STORE].setChildren(<Feedback />);
    this.props[MODAL_STORE].setTrigger('feedback');
    this.props[MODAL_STORE].openModal();
  }

  render() {
    const isLoggedIn = this.props[AUTH_STORE].isLoggedIn;
    const isAdministrator = this.props[AUTH_STORE].isAdministrator;
    const allProductsInCart = this.props[CART_STORE].allProducts;

    return (
      <div className="tilaussovellus">
        <NotificationContainer />
        <ModalContainer />
        {
          isLoggedIn ? (
            <div className="header">
              <div className="header__navigation">
                <NavLink className="navigation-item" to="/products">Tuotteet</NavLink>
                <NavLink className="navigation-item" to="/order">
                  <span>Tilaukseen</span>
                  <div className="header__cart">
                    <div className="cart" />
                    {
                      allProductsInCart.length > 0 ? (
                        <span className="cart__count">{allProductsInCart.length}</span>
                      ) : null
                    }
                  </div>
                </NavLink>
                {
                  isAdministrator ? (
                <a
                  className="navigation-item navigation-item--small"
                  onClick={() => this.clearcache()}
                ><div className="alert"/>
                </a>
                  ) : null
                }
                <NavLink
                  className="navigation-item navigation-item--small"
                  to="/history"
                >
                  Tilaushistoria
                </NavLink>
                <a
                  className="navigation-item navigation-item--small"
                  onClick={() => this.openFeedbackModal()}
                >anna palautetta
                </a>
                <a
                  className="navigation-item navigation-item--small"
                  onClick={() => this.logout()}
                >Kirjaudu ulos
                </a>
              </div>
            </div>
          ) : null
        }
        <div className="route-wrapper">
          <Router>
            <Switch>
              <Route exact={true} path="/" component={Login} />
              <PrivateRoute path="/products" component={ProductView} />
              <PrivateRoute path="/order" component={OrderForm} />
              <PrivateRoute path="/history" component={OrderHistory} />
            </Switch>
          </Router>
        </div>

        {/* Do not show navigation unless user is logged in*/}
        {/* {this.isDevelopment()} */}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App.tsx